import { render, staticRenderFns } from "./OverviewIndicators.vue?vue&type=template&id=0ae3e31a&scoped=true"
import script from "./OverviewIndicators.vue?vue&type=script&lang=js"
export * from "./OverviewIndicators.vue?vue&type=script&lang=js"
import style0 from "./OverviewIndicators.vue?vue&type=style&index=0&id=0ae3e31a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae3e31a",
  null
  
)

export default component.exports